var map = {
	"./audio/drumKit/cymbal.mp3": "47ac",
	"./audio/drumKit/highHat.mp3": "233e",
	"./audio/drumKit/kickDrum.mp3": "dd97",
	"./audio/drumKit/snareDrum.mp3": "e8bb",
	"./audio/drumKit/tomDrum.mp3": "c383",
	"./images/ObjectsRender/xNegTurn.svg": "81c8",
	"./images/ObjectsRender/xPosTurn.svg": "ce17",
	"./images/ObjectsRender/yNegTurn.svg": "07cc",
	"./images/ObjectsRender/yPosTurn.svg": "9acd",
	"./images/ObjectsRender/zNegTurn.svg": "8064",
	"./images/ObjectsRender/zPosTurn.svg": "730e",
	"./images/arrowLarge.svg": "21c7",
	"./images/backgroundGrid.png": "699f",
	"./images/backgroundLarge2.png": "a30b",
	"./images/blackGrid.png": "9160",
	"./images/blueGrid.png": "534a",
	"./images/cameraIcon.svg": "8d86",
	"./images/caveman/128VI.png": "cc86",
	"./images/caveman/NewPlayer/airSwing1.svg": "936e",
	"./images/caveman/NewPlayer/airSwing2.svg": "da6c",
	"./images/caveman/NewPlayer/airSwing3.svg": "0c5a",
	"./images/caveman/NewPlayer/airSwing4.svg": "189b",
	"./images/caveman/NewPlayer/airSwing5.svg": "f8d6",
	"./images/caveman/NewPlayer/airSwing6.svg": "5669",
	"./images/caveman/NewPlayer/down.svg": "680d",
	"./images/caveman/NewPlayer/hit1.svg": "e714",
	"./images/caveman/NewPlayer/hit2.svg": "c7b8",
	"./images/caveman/NewPlayer/run1.svg": "7672",
	"./images/caveman/NewPlayer/run2.svg": "91a8",
	"./images/caveman/NewPlayer/run3.svg": "6be6",
	"./images/caveman/NewPlayer/run4.svg": "8e99",
	"./images/caveman/NewPlayer/run5.svg": "0b02",
	"./images/caveman/NewPlayer/run6.svg": "9070",
	"./images/caveman/NewPlayer/run7.svg": "faf1",
	"./images/caveman/NewPlayer/run8.svg": "ab33",
	"./images/caveman/NewPlayer/stand.svg": "683e",
	"./images/caveman/NewPlayer/swingcycle1.svg": "a0f4",
	"./images/caveman/NewPlayer/swingcycle2.svg": "9db7",
	"./images/caveman/NewPlayer/swingcycle3.svg": "9ff9",
	"./images/caveman/NewPlayer/swingcycle4.svg": "7d05",
	"./images/caveman/NewPlayer/swingcycle5.svg": "7740",
	"./images/caveman/NewPlayer/swingcycle6.svg": "6960",
	"./images/caveman/NewPlayer/up.svg": "ed10",
	"./images/caveman/background5.png": "0a9e",
	"./images/caveman/background720.png": "76bb",
	"./images/caveman/deleteCross.svg": "9793",
	"./images/caveman/newText.png": "e501",
	"./images/caveman/numbers.png": "f977",
	"./images/caveman/obs/diamond.svg": "7945",
	"./images/caveman/obs/emerald.svg": "e5cd",
	"./images/caveman/obs/logs.svg": "5e56",
	"./images/caveman/obs/logsFire.svg": "66d6",
	"./images/caveman/obs/meat.svg": "97bd",
	"./images/caveman/obs/ruby.svg": "8ba6",
	"./images/caveman/obs/test.svg": "8488",
	"./images/caveman/obs/vent.svg": "49c7",
	"./images/caveman/stoneUI2.png": "9ed2",
	"./images/cavemanPlayOverlay.png": "4461",
	"./images/checkTicked.svg": "429c",
	"./images/checkUnticked.svg": "b4f8",
	"./images/clearGrid.png": "3deb",
	"./images/cog.svg": "e6ab",
	"./images/crossHair.svg": "9c09",
	"./images/deleteIcon.svg": "a2ef",
	"./images/downloadIcon.svg": "577a",
	"./images/dropDownButton.png": "23b1",
	"./images/dropDownButton.svg": "499c",
	"./images/drumKit/backdrop.svg": "f796",
	"./images/drumKit/cymbalLeft.svg": "7f64",
	"./images/drumKit/cymbalLeftHit.svg": "10d6",
	"./images/drumKit/cymbalRight.svg": "b307",
	"./images/drumKit/cymbalRightHit.svg": "36f5",
	"./images/drumKit/highHat.svg": "6b41",
	"./images/drumKit/highHatHit.svg": "8210",
	"./images/drumKit/kickDrum.svg": "fd8c",
	"./images/drumKit/kickDrumHit.svg": "7f07",
	"./images/drumKit/snare.svg": "56dd",
	"./images/drumKit/snareHit.svg": "efd4",
	"./images/drumKit/tomLarge.svg": "63a6",
	"./images/drumKit/tomLargeHit.svg": "86cc",
	"./images/drumKit/tomMid.svg": "21c7a",
	"./images/drumKit/tomMidHit.svg": "a527",
	"./images/drumKit/tomSmall.svg": "d4d5",
	"./images/drumKit/tomSmallHit.svg": "0ed4",
	"./images/errorPage.png": "a754",
	"./images/filterIcon.svg": "67b7",
	"./images/fishBowl/backdrop.png": "d739",
	"./images/fishBowl/backdrop.svg": "1853",
	"./images/fishBowl/bubble.svg": "9f2e",
	"./images/fishBowl/castle.svg": "ad80",
	"./images/fishBowl/crabBlink.svg": "3824",
	"./images/fishBowl/crabWalkOne.svg": "e57b",
	"./images/fishBowl/crabWalkTwo.svg": "6d85",
	"./images/fishBowl/fishBase.svg": "4660",
	"./images/fishBowl/fishBlinkOne.svg": "2503",
	"./images/fishBowl/fishBlinkTwo.svg": "2dc0",
	"./images/fishBowl/fishMove.svg": "69e2",
	"./images/fishBowl/rock.svg": "845b",
	"./images/fishPlayOverlay.png": "00d5",
	"./images/homeCarousel/caveman2.png": "0d53",
	"./images/homeCarousel/drumKit.png": "9af2",
	"./images/homeCarousel/fishbowl.png": "8e2c",
	"./images/homeCarousel/raycaster.png": "293a",
	"./images/homeCarousel/weather.png": "e26b",
	"./images/icons/arrow.svg": "5975",
	"./images/jsButtons/downer.svg": "5ce7",
	"./images/jsButtons/dropDownButton.svg": "d226",
	"./images/jsButtons/letters.png": "2c81",
	"./images/jsButtons/load.svg": "3483",
	"./images/jsButtons/loadS.svg": "4076",
	"./images/jsButtons/menuBar.svg": "f980",
	"./images/jsButtons/new.svg": "e15b",
	"./images/jsButtons/newS.svg": "c109",
	"./images/jsButtons/numbers.png": "0678",
	"./images/jsButtons/overwrite.svg": "cfcb",
	"./images/jsButtons/overwriteS.svg": "73b6",
	"./images/jsButtons/save.svg": "8fc9",
	"./images/jsButtons/saveS.svg": "8552",
	"./images/jsButtons/switchOff.svg": "49f5",
	"./images/jsButtons/switchOn.svg": "79f1",
	"./images/jsButtons/upper.svg": "a09b",
	"./images/jsButtons/xSlider.svg": "62fa",
	"./images/jsButtons/ySlider.svg": "9784",
	"./images/linkIcons/css.png": "3c05",
	"./images/linkIcons/gimp.png": "36e0",
	"./images/linkIcons/html.png": "c99e",
	"./images/linkIcons/js.png": "f9f8",
	"./images/linkIcons/originals/css.png": "692f",
	"./images/linkIcons/originals/gimp.png": "e339",
	"./images/linkIcons/originals/html.png": "cfee",
	"./images/linkIcons/originals/js.png": "c962",
	"./images/linkIcons/originals/pinia.png": "032a",
	"./images/linkIcons/originals/scratch.png": "96d4",
	"./images/linkIcons/originals/vue.png": "2641",
	"./images/linkIcons/pinia.png": "1840",
	"./images/linkIcons/scratch.png": "b5cc",
	"./images/linkIcons/vsc.png": "83cc",
	"./images/linkIcons/vue.png": "8bc0",
	"./images/noTouch.svg": "c636",
	"./images/projectLinks/bballSheet.png": "80ab",
	"./images/projectLinks/buttonsLink.png": "6a22",
	"./images/projectLinks/carouselLink.png": "5001",
	"./images/projectLinks/cavemanLink.png": "1107",
	"./images/projectLinks/drumKitLink.png": "f91e",
	"./images/projectLinks/fishBowlLink2.png": "13d2",
	"./images/projectLinks/gameControllerLink.png": "5195",
	"./images/projectLinks/objectRenderLink.png": "1832",
	"./images/projectLinks/pharaoh.png": "cea4",
	"./images/projectLinks/raycasterLink.png": "21d5",
	"./images/projectLinks/scratchLink.png": "29d5",
	"./images/projectLinks/textBoxLink.png": "defe",
	"./images/projectLinks/touchPaintLink2.png": "2877d",
	"./images/projectLinks/weatherLink3.png": "7401",
	"./images/raycaster/background.png": "f929",
	"./images/raycaster/close.svg": "ae15",
	"./images/raycaster/close2.svg": "6135",
	"./images/raycaster/full.svg": "483d",
	"./images/raycaster/full2.svg": "3357",
	"./images/raycasterPlayOverlay.png": "662c",
	"./images/raycasterWalls/background1a.png": "c525",
	"./images/raycasterWalls/outside.png": "f917",
	"./images/raycasterWalls/pharaohTextWings.svg": "0ffb",
	"./images/rotate.svg": "600a",
	"./images/scoreSheet/box.png": "c738",
	"./images/scoreSheet/details.png": "acd1",
	"./images/scoreSheet/end.png": "1e4e",
	"./images/scoreSheet/home.png": "d440",
	"./images/scoreSheet/logging.png": "01cc",
	"./images/scoreSheet/score.png": "c492",
	"./images/selectArrow.svg": "dd10",
	"./images/shadowExpand.svg": "6f71",
	"./images/textBoxes/newText.png": "4b0b",
	"./images/tombOverlay.png": "9acc",
	"./images/underConstruction.png": "06bd",
	"./images/weather/01d@2x.png": "a841",
	"./images/weather/01n@2x.png": "7c99",
	"./images/weather/02d@2x.png": "0345",
	"./images/weather/02n@2x.png": "500a",
	"./images/weather/03d@2x.png": "65bc",
	"./images/weather/03n@2x.png": "9b91",
	"./images/weather/04d@2x.png": "ccb8",
	"./images/weather/04n@2x.png": "4713",
	"./images/weather/09d@2x.png": "8ba5",
	"./images/weather/09n@2x.png": "a8d2",
	"./images/weather/10d@2x.png": "ea4e",
	"./images/weather/10n@2x.png": "5220",
	"./images/weather/11d@2x (1).png": "7c6c",
	"./images/weather/11d@2x.png": "e5a3",
	"./images/weather/11n@2x.png": "806a",
	"./images/weather/13d@2x.png": "ba6e",
	"./images/weather/13n@2x.png": "6ca8",
	"./images/weather/50d@2x.png": "a2dc",
	"./images/weather/50n@2x.png": "f1ed",
	"./plugins/carousel/carousel": "5a2b",
	"./plugins/carousel/carousel.css": "0a8a",
	"./plugins/carousel/carousel.js": "5a2b",
	"./plugins/carousel/carouselVue": "82f1",
	"./plugins/carousel/carouselVue.js": "82f1",
	"./plugins/carousel/images/arrowLeft.svg": "e1c1",
	"./plugins/carousel/images/arrowRight.svg": "5fa2",
	"./plugins/carousel/images/fishbowl.png": "e2c6",
	"./plugins/carousel/images/platformer.png": "2771",
	"./plugins/carousel/images/raycaster.png": "473d",
	"./plugins/carousel/images/raycaster2.png": "9a40"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "83cb";